import '@babel/polyfill'
import Vue from 'vue'
import router from './router'
import store from './store'
import './plugins/vuetify'
import './plugins/axios'
import './plugins/vee-validate'
import './plugins/v-calendar'
import App from './App.vue'
import moment from 'moment'
import 'moment-duration-format'
import './plugins/vue-auth/vue-auth'
import Toast from './components/Toast'
import VueClipboard2 from 'vue-clipboard2'

Vue.use(VueClipboard2)

Vue.config.productionTip = false

Vue.filter('formatDate', (value, format) => {
  if (value) {
    const localDate = moment(value).toDate()
    format = format || 'DD/MM/YYYY HH:mm'
    return moment(localDate).format(format)
  }
})

Vue.filter('formatDuration', (value, type = 'seconds', format = 'h [hrs] m [min] s [seconds]') => {
  if (value) {
    return moment.duration(value, type).format(format)
  }
})

Vue.filter('formatBoolean', function (value) {
  if (value) {
    return 'Yes'
  } else {
    return 'No'
  }
})

Vue.filter('formatPercentage', (value, precision = 2) => {
  if (value) {
    let percentValue = value * 100
    if (precision) {
      percentValue = percentValue.toFixed(precision)
    }
    return `${percentValue} %`
  }
  return ''
})

Vue.filter('formatPrec', (value, precision = 3) => {
  if (value) {
      return value.toFixed(precision)
  }
  return ''
})

const languages = {
  'en': 'English',
  'tr': 'Turkish'
}

Vue.filter('formatLanguageCode', function (value) {
  if (value) {
    return languages[value] || value
  }
})

Vue.prototype.$toast = Toast

Vue.mixin({
  methods: {
    handleAxiosError (error) {
      store.dispatch('loader/setLoader', {
        loading: false
      })
      if (error.response) {
        // The request was made and the server responded with a status code
        // that falls out of the range of 2xx
        let errorMessage = error.response.data.error_description || error.response.data.error || 'Error!'
        if (error.response.status === 401) {
          errorMessage = 'Session timeout!'
        }
        this.$toast.open({
          text: errorMessage,
          type: 'error'
        })
      } else if (error.request) {
        // The request was made but no response was received
        // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
        // http.ClientRequest in node.js
        console.log(error.request)
      } else {
        // Something happened in setting up the request that triggered an Error
        console.log('Error', error.message)
      }
    },
    validateBeforeSubmit (callback) {
      this.$validator.validateAll().then((result) => {
        if (result) {
          callback()
        } else {
          this.$toast.open({
            text: 'Form is not valid',
            type: 'error'
          })
        }
      })
    }
  }
})

new Vue({
  router,
  store,
  render: h => h(App),
  created () {
    this.$auth.ready(() => {
      if (this.$auth.check()) {
        this.$store.dispatch('configurations/getConfigurations')
      }
    })
  }
}).$mount('#app')
